import { useFadeIn } from './useFadeIn';

export default function Mission() {
  const leftRef = useFadeIn();
  const rightRef = useFadeIn();

  return (
    <section id="mission" data-testid="mission-section" className="mission-section">
      {/* Background grid */}
      <div className="mission-bg" aria-hidden="true">
        <svg width="100%" height="100%" viewBox="0 0 1440 500" preserveAspectRatio="xMidYMid slice">
          {[...Array(6)].map((_, i) => (
            <line key={`v${i}`} x1={240 * i} y1="0" x2={240 * i} y2="500"
              stroke="#000" strokeWidth="0.5" opacity="0.04" />
          ))}
          {[...Array(5)].map((_, i) => (
            <line key={`h${i}`} x1="0" y1={100 * i} x2="1440" y2={100 * i}
              stroke="#000" strokeWidth="0.5" opacity="0.04" />
          ))}
          <circle cx="1200" cy="250" r="200" stroke="#000" strokeWidth="0.8" fill="none" opacity="0.05"/>
          <circle cx="1200" cy="250" r="130" stroke="#000" strokeWidth="0.8" fill="none" opacity="0.04"/>
          <circle cx="1200" cy="250" r="60"  stroke="#000" strokeWidth="0.8" fill="none" opacity="0.04"/>
        </svg>
      </div>

      <div className="mission-inner">
        {/* Left label block */}
        <div ref={leftRef} className="mission-left fade-up">
          <p className="sec-overline">Who we are</p>
          <h2 className="mission-heading">Our<br />Mission.</h2>
          <div className="mission-divider" />
          <p className="mission-sub">What drives every campaign<br />we build.</p>
        </div>

        {/* Right — mission copy */}
        <div ref={rightRef} className="mission-right fade-up d1">
          <span className="mission-quote-mark">"</span>
          <p className="mission-body">
            To build a thriving space where talent finds its stage and brands find their story. We exist to connect the right voices with the right brands — creating campaigns that go beyond reach and deliver real, meaningful growth.
          </p>
          <p className="mission-body mission-body-2">
            Our purpose is simple: to raise the bar for influencer marketing in India and be the agency that people and brands genuinely trust, return to, and grow with.
          </p>
        </div>
      </div>
    </section>
  );
}
